import { render, staticRenderFns } from "./writeOffRecords.vue?vue&type=template&id=2ddd9c13&scoped=true"
import script from "./writeOffRecords.vue?vue&type=script&lang=js"
export * from "./writeOffRecords.vue?vue&type=script&lang=js"
import style0 from "./writeOffRecords.vue?vue&type=style&index=0&id=2ddd9c13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd9c13",
  null
  
)

export default component.exports